import moment from "moment";
import { Timestamp } from "../../cores/socialChat/interfaces/conversations.interface";

export const formatConversationListTimestamp = (timestamp: Timestamp) => {
  const full = timestamp?.full;
  if (full) {
    const parsed = moment(full);
    if (parsed.isValid()) {
      const datePart = parsed.format("D MMM");
      const timePart = parsed.format("HH:mm");
      return `${datePart} ${timePart}`;
    }
  }

  const date = String(timestamp?.date ?? "").trim();
  const time = String(timestamp?.time ?? "").trim();
  if (date && time) return `${date} ${time}`;
  return date || time;
};
